import pubsub from "@viewlift/pubsub";
import { fetchUserDetails } from "./MFEs/Monetization-Sdk/src/fetchStore";
import { trackFbEvent, trackPixelEvent, trackUserEvent } from "./helpers/trackAnalytics";

export const listenAnalyticEvents = async() => {
    let { userId="",profileId="" } =  await fetchUserDetails();
    const clientId=window.app_data.appcmsMain.id;
    const platform='Website'
     pubsub.subscribe('user-analytics',async({ename,data}) => {
        let payload = [{
            siteid: clientId,
            uid: userId,
            pfm: platform,
            ename: ename,
            ref: window.document.referrer,
            url: window.location.href,
            environment: window.env,
            etstamp:new Date().toISOString().slice(0, 19).replace('T', ' '),
            profid : profileId,
            eventdata:  data || {}
        }]
        await trackUserEvent(payload);
    })
}

export const listenFBEvents = async() => {
     pubsub.subscribe('FB-analytics', ({eventType,payload,type}) => {
        let conversionApi = window?.app_data?.appcmsMain?.analytics?.conversionApi
        let conversionApiEnabled = conversionApi?.conversionApi
        let pixelID = conversionApi?.pixelID
    if (type === "FB" && conversionApiEnabled) trackFbEvent(eventType,payload)
        if (type === "PIXEL" && pixelID) trackPixelEvent(eventType,payload)
    })
}
